import axios from "axios";
import store from "@/store"
import JwtService from "@/common/jwtService";
import { REFRESH_TOKEN } from '@/store/actions/auth';
import { AUTH_LOGOUT } from "../store/actions/auth";

export const API_URL = "https://www.ptspapi.citi-serve.com/";
// export const API_URL = "http://localhost:8000/";

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': {
      toString () {
        return `Bearer ${localStorage.getItem('token')}`
      }
    }
  }
});

api.interceptors.response.use(function (response) {
    // Do something with response data
    const now = Date.now()
    if (now - store.state.auth.lastLogin > 43200000) {
      store.dispatch(REFRESH_TOKEN)
    }
    return response;
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  });

export const errorFn = error => {
  if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
    if (error.response.status == 400) {
      throw new Error(Object.keys(error.response.data))
    }
    if (error.response.status == 401) {
      store.dispatch(AUTH_LOGOUT)
    }
  } else if (error.request) {
    console.log("Request ERR: ", error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  console.log(error.config);
};

export default api;

